import MainLayout from "@/components/layouts";
import { ScheduleEditor } from "./components/schedule-editor";
import { useIndividualSchedule } from "./schedule.hooks";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export default function IndividualSchedulePage() {
  const { weeklySchedule, loading, saving, error, saveSchedule, retry } = useIndividualSchedule();

  if (error) {
    return (
      <MainLayout>
        <div className="container mx-auto py-6">
          <Card className="border-red-200 bg-red-50">
            <CardHeader>
              <div className="flex items-center gap-2 text-red-800">
                <AlertCircle className="h-5 w-5" />
                <CardTitle className="text-lg">Error Loading Schedule</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <p className="text-red-700 mb-4">{error}</p>
              <button onClick={retry} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
                Try Again
              </button>
            </CardContent>
          </Card>
        </div>
      </MainLayout>
    );
  }

  if (loading || weeklySchedule === null) {
    return (
      <MainLayout>
        <div className="container mx-auto py-6 space-y-6">
          <div className="space-y-2">
            <Skeleton className="h-8 w-48" />
            <Skeleton className="h-4 w-96" />
          </div>

          <div className="grid gap-6">
            <Card>
              <CardHeader>
                <Skeleton className="h-6 w-32" />
                <Skeleton className="h-4 w-64" />
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  {Array.from({ length: 7 }).map((_, i) => (
                    <div key={i} className="flex items-center justify-between p-4 border rounded">
                      <Skeleton className="h-4 w-20" />
                      <div className="flex gap-2">
                        <Skeleton className="h-8 w-16" />
                        <Skeleton className="h-8 w-20" />
                        <Skeleton className="h-8 w-20" />
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="container mx-auto py-6 space-y-6">
        <div className="space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">My Schedule</h1>
          <p className="text-muted-foreground">Manage your weekly availability</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Weekly Availability</CardTitle>
            <CardDescription>Set your regular working hours for each day of the week</CardDescription>
          </CardHeader>
          <CardContent>
            <ScheduleEditor weeklySchedule={weeklySchedule} saving={saving} saveSchedule={saveSchedule} />
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
}
